import { useMutation, useQueryClient } from "@tanstack/react-query"
import { uploadProductImage } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useUploadProductImage(productId: string) {
  const token = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      file,
      caption,
      order,
    }: {
      file: File
      caption?: string
      order?: number | string
    }) => {
      if (!token) throw new Error("No token available")
      return uploadProductImage(productId, file, caption, order, token)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product", productId] })
    },
  })
}
